import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Logger } from '../logging/default-log.service';
import { FilterState } from '../classes/filter.state';
import { ProductDetail } from '../classes/product.detail';
import { BaseService } from './base.service';
import { HttpClient } from './http.service';
import { Product } from '../classes/product';

/**
 * Base for favorite service
 *
 * @author hillebrand
 */
@Injectable()
export class FavoriteService extends BaseService {
  private favoritesUrl = '/rest/favorite';

  constructor(
    private http: HttpClient,
    logger: Logger
  ) {
    super(logger);
  }

  /**
   * checks current favorite state and determines if it needs to be added or removed.
   *
   * @param product
   * @param isFavorite
   * @param filterState
   *
   * @returns {Observable<R>}
   */
  toggleFavorite(
    product: Product | ProductDetail,
    filterState: FilterState
  ): Observable<boolean> {
    let url = this.favoritesUrl;
    url += product.favorite ? '/remove' : '/add';
    url += `?type=${product.type}&priceListNo=${product.priceListNo}&priceListLineNo=${product.priceListLineNo}`;

    // Effectuate immediately favorite toggle without awaiting response of backend.
    product.favorite = !product.favorite;

    if (filterState && filterState.languageCode) {
      url += `&languageCode=${filterState.languageCode}`;
    }

    return this.http.post<boolean>(url, '');
  }
}
